import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrgProject } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrgProject>();

export class VolunteerOrgProjectFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrgProject>
  >((filters) => filterWithRelationsAndJson(VolunteerOrgProject)(filters));
}
